module.exports = __webpack_public_path__ + "img/ucb.c26cdf76.png";